import { render, staticRenderFns } from "./formulaMedicaShow.vue?vue&type=template&id=4e4e88f6&"
import script from "./formulaMedicaShow.vue?vue&type=script&lang=js&"
export * from "./formulaMedicaShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports